export default __webpack_public_path__ + "static/1-afe554eb55946933a8f4ea161ebdfe27.png";